export default "__VITE_ASSET__a43b317d__"